import { debug, george, i18n, pr, React, theme, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { ShowCardDataRoutes } from "./ShowCardDataRoutes";
import ShowCardDataStore from "./ShowCardDataStore";

type IProps = {
    store: ShowCardDataStore
};

export const ShowCardDataSigning = ({ store }: IProps) => {
    const [isLoading, setIsLoading] = React.useState(false);

    const handleSigningSuccess = async (res: ISigningResponse) => {
        store.signingResponse = res;

        // Not a captcha PIN -> need to get the PIN from the response ID
        try {
            setIsLoading(true);
            await store.getCardData();
            setIsLoading(false);
            pushRoute(ShowCardDataRoutes.DETAILS);
        } catch (err) {
            debug.log("### getCardData failed", err);
            setIsLoading(false);
            pushRoute("/error");
        }
    };

    return (
        <SigningComponent
            signingInfo={store.signInfo}
            useWebVersion
            content={
                <div style={{ padding: theme.MARGIN }}>
                    <george.ResponsiveSummaryElement label={ui.__("signing.action.label")}>
                        <pr.SigningLabel><i18n.FormattedMessage id="showCardData.action.title" /></pr.SigningLabel>
                    </george.ResponsiveSummaryElement>

                    <george.ResponsiveSummaryElement label={ui.__("signing.card.label")} >
                        <pr.SigningLabel>{store.cardStore.card ? store.cardStore.card.number : "-"}</pr.SigningLabel>
                    </george.ResponsiveSummaryElement>

                </div>}
            onSuccess={handleSigningSuccess}
            // onRetry={async () => { await store.resetPin(); }}
            isLoading={isLoading}
        />
    );

};



// WEBPACK FOOTER //
// ./src/components/showCardData/ShowCardDataSigning.tsx